<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('ads')">Localidad</inertia-link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.nombre }}
    </h1>
          <!-- <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('category')">Cancelar Cambios</inertia-link> -->

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <!-- <span class="pr-6 pb-8 w-full" >Url:  {{ slug}} </span> -->
          <!-- <text-input v-model="slug" disabled :error="form.errors.url" class="pr-6 pb-8 w-full lg:w-1/2" label="Url" /> -->
          <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
          <!-- <text-area-input v-model="" :error="form.errors.texto" class="pr-6 pb-8 w-full lg:w-1/2" label="Texto" /> -->
          <text-area-input v-model="form.ubicacion" :error="form.errors.ubicacion" class="pr-6 pb-8 w-full lg:w-1/2" label="Ubicacion" />
          <text-input v-model="form.mapongo" :error="form.errors.mapongo" class="pr-6 pb-8 w-full lg:w-1/2" label="Mapa Coordenadas" />
           <vue-editor class="w-full mb-12" v-model="form.texto"  :editor-toolbar="customToolbar"  />
        </div>
        <div class="px-8 mt-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar Localidad</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import { VueEditor } from "vue2-editor";


export default {
  metaInfo() {
    return { title: this.form.nombre }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    VueEditor,
    TrashedMessage,
    TextAreaInput
  },
  layout: Layout,
  props: {
    zona: String,
    location: Object,
  },
  remember: 'form',
  computed: {
    slug: function() {
      let slug = 'https://lapedrera.com.uy/localidad-'+this.sanitizeTitle(this.form.nombre);
      return slug;
    }
  },
  data() {
    return {
      customToolbar: [
      [{ header: [false, 2] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        // [
        //   { align: "" },
        //   { align: "center" },
        //   { align: "right" },
        //   { align: "justify" }
        // ],
        // ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link"],
        ["clean"] // remove formatting button,
      ],
      form: this.$inertia.form({
        url: this.location.url,
        nombre: this.location.nombre,
        texto: this.location.texto,
        ubicacion: this.location.ubicacion,
        publicado: this.location.publicado,
        mapongo: this.location.mapongo,
      }),
    }
  },
  methods: {
    sanitizeTitle: function(title) {
      // console.log(title);
      if(title){
        var slug = "";
        // Change to lower case
        var titleLower = title.toLowerCase();
        // Letter "e"
        slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
        // Letter "a"
        slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
        // Letter "o"
        slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
        // Letter "u"
        slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
        // Letter "d"
        slug = slug.replace(/đ/gi, 'd');
        // Trim the last whitespace
        slug = slug.replace(/\s*$/g, '');
        // Change whitespace to "-"
        slug = slug.replace(/\s+/g, '-');
        
        return slug;
      } else {
        return '';
      }
      
    },
    update() {
      this.form.put(this.route('locations.update', this.location.zona))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia.delete(this.route('locations.ads', this.location.zona))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(this.route('locations.restore', this.location.zona))
         this.form.post(this.route('locations.store'))
      }
    },
  },
}
</script>
